import { CurrencyCode } from '@ankor-io/common/domain/pay/supported.currencies'

/**
 * Format a currency amount to a string
 * @param amount In dollars, not cents
 * @param currency The currency code
 * @returns Formatted currency string in format: #,###.## CUR
 */
export const formatCurrency = (amount: number, currency?: string) => {
  const currencyCode = currency || CurrencyCode.USD
  const formattedAmount = new Intl.NumberFormat('en-US', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(amount || 0)

  return `${formattedAmount} ${currencyCode}`
}

export const formatThousandsOnly = (value: string): string => {
  if (!value) {
    return ''
  }

  // Remove commas before parsing to handle values like "1,000"
  const cleanedValue = value.replace(/,/g, '')
  const num = parseFloat(cleanedValue)
  if (isNaN(num)) {
    return ''
  }

  // Use Math.floor to truncate decimals and convert to integer
  return Math.floor(num).toLocaleString('en-US')
}

export const formatThousandsWithDecimals = (value: string): string => {
  if (!value) {
    return ''
  }

  // Remove commas before parsing to handle values like "1,000"
  const cleanedValue = value.replace(/,/g, '')
  const num = parseFloat(cleanedValue)
  if (isNaN(num)) {
    return ''
  }

  // Format with thousands separators while preserving decimal places
  return num.toLocaleString('en-US', {
    minimumFractionDigits: 0,
    maximumFractionDigits: 2,
  })
}
